import { useQuery } from "@tanstack/react-query";
import { t } from "ttag";

import { env } from "@/config/env";
import { referralQueriesStore } from "@/features/referral/api";
import { Alert, GiftIcon } from "@/shared/ui";

const referralEnabled = env.VITE_REFERRAL_ENABLED;

export const QueuedCreditAlert = () => {
  const { data: credit } = useQuery({
    ...referralQueriesStore.credit,
    enabled: referralEnabled,
  });

  if (!credit?.queued) {
    return null;
  }

  return (
    <Alert icon={GiftIcon}>
      {t`$${credit.queued} off of your next invoice from referral credit`}
    </Alert>
  );
};
